import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
import { generateHeadingStyles } from '../../styles/jss/common';
const useStyles = makeStyles()((theme, _params, classes) => ({
    container: {
        // For full width image to position against
        position: 'relative',
        display: 'flex',
        // Mobile - image below content
        flexDirection: 'column-reverse',
        placeContent: 'center',
        overflow: 'hidden',
        '& video': {
            display: 'block',
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            objectFit: 'cover',
        },
    },
    content: {
        width: '100%',
        alignSelf: 'center',
        position: 'absolute',
        [theme.breakpoints.up('sm')]: {
            position: 'relative',
            width: '50%',
            alignSelf: 'center',
        },
    },
    contentInner: {
        width: '100%',
        margin: spacing.large,
        [theme.breakpoints.between('sm', 'lg')]: {
            marginBottom: '56px',
        },
        [theme.breakpoints.up('md')]: {
            margin: spacing.xxl,
            alignSelf: 'center',
        },
        [theme.breakpoints.up('xl')]: {
            margin: '128px',
            alignSelf: 'center',
        },
        '& > :last-child': {
            marginBottom: '0px',
        },
    },
    // We need to override the default positioning of Content Container
    homeVideoMobileContent: {
        height: '100%',
    },
    adjustMessage: {
        marginBottom: 0,
        [theme.breakpoints.up('sm')]: {
            marginBottom: spacing.xs,
            textAlign: 'left',
        },
    },
    newMessage: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_regular), theme.typographySpacing.none), { textAlign: 'left', color: colors.supplementary.white, [theme.breakpoints.up('xs')]: {
            marginBottom: spacing.large,
        }, [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.small_bold_sm), [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.large_regular), theme.typographySpacing.large_regular_sm) }),
    mobilePositionBottom: {
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    homeVideoContainer: {
        justifyContent: 'center',
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'start',
        },
    },
    videoContainer: {
        // default on mobile the image is full width and positioned above or below the content
        width: '100%',
        position: 'relative',
        // Make square on mobile
        paddingTop: '100%',
        [theme.breakpoints.up('xs')]: {
            // Use min heights on tablet up
            paddingTop: 0,
        },
        [theme.breakpoints.up('sm')]: {
            // default on desktop is for image to be 50% wide unless fullImage
            width: '50%',
        },
        // backup  image min height if other min heights not used
        minHeight: '200px',
    },
    heading: Object.assign({}, generateHeadingStyles(theme, spacing, colors)),
    subheading: Object.assign(Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.none), { marginBottom: '10px', textAlign: 'center', [theme.breakpoints.up('sm')]: {
            display: 'block',
            textAlign: 'left',
            marginBottom: spacing.medium,
        }, [theme.breakpoints.up('xl')]: Object.assign(Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.none), { marginBottom: spacing.medium }) }),
    message: {
        textAlign: 'center',
        color: colors.supplementary.white,
        '& p': Object.assign(Object.assign({}, theme.typography.small_regular), { margin: `${spacing.small} 0px 0px `, [theme.breakpoints.up('sm')]: Object.assign(Object.assign({}, theme.typography.medium_regular), { margin: `${spacing.small} 0px ${spacing.large}` }) }),
    },
    linkContainer: {
        display: 'none',
        [theme.breakpoints.up('sm')]: { display: 'block' },
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            flexDirection: 'row',
            margin: `0 -${spacing.xs}`,
            '& a': {
                width: '50%',
                flexDirection: 'column',
                flexGrow: 1,
                margin: 0,
            },
        },
        '& button': { width: '100%' },
    },
    outsideLinkContainer: {
        marginTop: spacing.large,
        marginLeft: '20px',
        marginRight: '20px',
        display: 'block',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    outsideSubheading: {
        marginTop: spacing.medium,
        marginLeft: '20px',
        marginRight: '20px',
        display: 'block',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    link: {
        width: '100%',
        display: 'flex',
        marginBottom: spacing.small,
        '&:last-child': {
            marginBottom: 0,
        },
        '& button': {
            flexGrow: 1,
            whiteSpace: 'pre-wrap',
        },
    },
    headingLine: {
        whiteSpace: 'nowrap',
        alignSelf: 'flex-start',
        padding: spacing.xs,
        '&:first-child': {
            transform: 'rotate(358deg) translate(5px,5px)',
            transformOrigin: 'bottom left',
        },
    },
    ffMessage: {
        display: 'block',
        color: colors.supplementary.black,
        '@media(orientation: landscape)': {
            display: 'none',
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: spacing.small,
        },
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    COBALT: {
        backgroundColor: colors.cobalt[500],
    },
    JADE: {
        backgroundColor: colors.jade[500],
    },
    WILD_EXOTIC: {
        backgroundColor: colors.wildExotic[500],
    },
    image: {
        '& img': {
            // flying flowers image is contained and positioned at the bottom
            objectFit: 'contain',
            objectPosition: 'bottom',
            [theme.breakpoints.down('xl')]: {
                maxHeight: '185px !important',
            },
        },
    },
    positionElement: {
        position: 'relative',
        [theme.breakpoints.up('sm')]: {
            position: 'unset !important',
        },
    },
    subMessageTitle: {},
    subMessage: {},
    subMessageContainer: {
        textAlign: 'center',
        display: 'flex',
        padding: `0 ${theme.spacing(2)}`,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            padding: '14px 0',
        },
        [`& .${classes.subMessageTitle}`]: Object.assign(Object.assign({}, theme.typography.small_bold), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.large_bold) }),
        [`& .${classes.subMessage}`]: Object.assign(Object.assign({}, theme.typography.small_regular), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.large_regular) }),
    },
    ffCenterContentInner: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    ffContent: {
        [theme.breakpoints.up('sm')]: {
            width: '50% !important',
        },
    },
    ffVideoContentInner: {
        display: 'block',
        [theme.breakpoints.up('md')]: {
            display: 'initial',
            marginBottom: spacing.large,
        },
    },
    centerHeading: {
        alignSelf: 'center',
    },
    outsideShowTrustpilotWidget: {
        minHeight: '60px',
        display: 'flex',
        marginTop: spacing.small,
        marginLeft: '20px',
        marginRight: '20px',
        padding: '18px',
        justifyContent: 'center',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    ffVideoCenter: {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'initial !important',
        },
    },
    positionLeft: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row-reverse',
        },
    },
    positionRight: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            [`& .${classes.content}`]: {
                justifyContent: 'right',
            },
        },
    },
    positionCenter: {
        [theme.breakpoints.up('sm')]: {
            [`& .${classes.content}`]: {
                width: '100%',
            },
        },
    },
    mobilePositionOver: {
        [theme.breakpoints.down('sm')]: {
            [`& .${classes.image}`]: {
                position: 'absolute',
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
            },
        },
    },
    ffVideoMessage: Object.assign(Object.assign({ display: 'none', marginTop: spacing.small, '@media(orientation: landscape)': {
            display: 'block',
        } }, theme.typography.small_regular), { margin: `${spacing.small} 0px 0px `, [theme.breakpoints.up('sm')]: Object.assign(Object.assign({ display: 'block' }, theme.typography.small_regular), { margin: `${spacing.small} 0px ${spacing.large}` }), [theme.breakpoints.up('lg')]: Object.assign({}, theme.typography.medium_regular) }),
}));
export default useStyles;
